import { DrawingState, Mode, DrawingStateFns, ModeVehicleColor } from "./ModeContext";
import { VehicleColor, showVehicleColor } from "./VehicleColor";

export function createVehicleColorMode( color: VehicleColor ): ModeVehicleColor {
    return { mode: Mode.VehicleColor, color };
}

export const vehicleColorModeFns: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        const mode = drawMode as ModeVehicleColor;
        return [
            { key: "q", label: "White",  color: "white",   active: mode.color === VehicleColor.White  },
            { key: "w", label: "Black",  color: "black",   active: mode.color === VehicleColor.Black  },
            { key: "e", label: "Gray",   color: "gray",    active: mode.color === VehicleColor.Gray   },
            { key: "r", label: "Silver", color: "silver",  active: mode.color === VehicleColor.Silver },
            { key: "t", label: "Red",    color: "red",     active: mode.color === VehicleColor.Red    },
            { key: "a", label: "Green",  color: "green",   active: mode.color === VehicleColor.Green  },
            { key: "s", label: "Blue",   color: "blue",    active: mode.color === VehicleColor.Blue   },
            { key: "d", label: "Brown",  color: "brown",   active: mode.color === VehicleColor.Brown  },
            { key: "f", label: "Orange", color: "orange",  active: mode.color === VehicleColor.Orange },
            { key: "g", label: "Purple", color: "purple",  active: mode.color === VehicleColor.Purple },
            { key: "z", label: "Gold",   color: "gold",    active: mode.color === VehicleColor.Gold   },
            { key: "x", label: "Yellow", color: "yellow",  active: mode.color === VehicleColor.Yellow },
            null,
            null,
            { key: "b", label: "Unsure", color: "gray",    active: mode.color === VehicleColor.Unsure },
        ];
    },

    onKeyDown( drawMode, key, shift, ctx ) {
        const mode = drawMode as ModeVehicleColor;
        if( key === "q" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.White  } ); return true; }
        if( key === "w" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Black  } ); return true; }
        if( key === "e" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Gray   } ); return true; }
        if( key === "r" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Silver } ); return true; }
        if( key === "t" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Red    } ); return true; }
        if( key === "a" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Green  } ); return true; }
        if( key === "s" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Blue   } ); return true; }
        if( key === "d" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Brown  } ); return true; }
        if( key === "f" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Orange } ); return true; }
        if( key === "g" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Purple } ); return true; }
        if( key === "z" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Gold   } ); return true; }
        if( key === "x" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Yellow } ); return true; }
        if( key === "b" ) { ctx.setDrawMode( { ...mode, color: VehicleColor.Unsure } ); return true; }
        return false;
    },

    onDeckClick( drawMode, info, ctx ) {},

    onDeckHover( drawMode, info, ctx ) {},

    onAnnotationClick( drawMode, ann, ctx ) {
        const mode = drawMode as ModeVehicleColor;
        ctx.handleEdit( { ...ann, attributes: { ...ann.attributes, color: showVehicleColor( mode.color ) } } );
    },

    filter( drawMode, ann ) {
        const mode = drawMode as ModeVehicleColor;
        const colorCompare = showVehicleColor( mode.color );
        return ann.attributes?.color === colorCompare;
    },

    getLineColor( drawMode, ann, ctx ) {
        const { obbAnnotationId: id, attributes: attrs } = ann;
        const done  = !( attrs.color === null );
        const alpha = id == ctx.hovObj?.obbAnnotationId ? 224 : 160;
        if( !done    ) { return [ 255, 255, 0, alpha ]; } //bright yellow
        if(  done    ) { return [   0, 255, 0, alpha ]; } //bright green
        return [255, 0, 0, 255];
    },

    getCursor( drawMode ) {
        return "grab";
    },

    getAnnotationLabel( drawMode, ann ) {
        const color = ann.attributes?.color ?? " ";
        return color[0].toUpperCase();
    }
};